import { AxiosError, HttpStatusCode } from 'axios'

import { ServerValidationError } from '@/api/shared/types'

export const AUTO_NUMBER_SERVER_ERROR_FIELD_REGEX = /^\/autos\/(\d+)\/number$/
export const PERSON_SERVER_ERROR_FIELD_REGEX = /^\/persons\/(\d+)$/

export const hasAutoNumberServerError = (field: string) =>
  AUTO_NUMBER_SERVER_ERROR_FIELD_REGEX.test(field)

export const hasPersonServerError = (field: string) =>
  PERSON_SERVER_ERROR_FIELD_REGEX.test(field)
export const PERIOD_SERVER_ERROR_FIELDS = ['from', 'to']

export const hasPeriodServerError = (field: string) =>
  PERIOD_SERVER_ERROR_FIELDS.includes(field)

export const isServerValidationError = (
  error?: AxiosError<ServerValidationError> | null
): boolean => {
  if (!error) {
    return false
  }

  return (
    error.response?.status === HttpStatusCode.BadRequest &&
    error.response?.data?.type === 'validation_error'
  )
}

export const parseServerErrorField = (field: string): number | null => {
  if (!field) {
    return null
  }

  const match =
    AUTO_NUMBER_SERVER_ERROR_FIELD_REGEX.exec(field) ??
    PERSON_SERVER_ERROR_FIELD_REGEX.exec(field)

  if (!match) {
    return null
  }

  const index = Number.parseInt(match[1], 10)
  return Number.isNaN(index) ? null : index
}
